import 'jquery';

$('.btn').each( function() {
  if (!$(this).hasClass('btn--icon-no')) {
    $(this).append('<div class="btn--icon"><i class="fas fa-chevron-right"></i></div>');
  }
});
